import React from "react"
import Grid from "@mui/material/Grid";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {CmCollectionType, CmTeasableType} from "../../types";
import C021KachelTeaserDeprecatedCard from "./C021KachelTeaserDeprecatedCard";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import useWindowSize from "../../../utility/useWindowSize";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";


export interface Props {
    cmCollection: CmCollectionType
    useSquareImage?: boolean
    headline?: string
}

function C021KachelTeaserDeprecated(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize()
    const shouldUseResponsiveFontSize = (props.cmCollection.viewtype === 'c021_kachel_teaser')
                                        && props.cmCollection.items!.length >= 3;
    return (
        <CCOComponentWrapper>
            <CCOHeadline metadataId={props.cmCollection.id} id={props.cmCollection.id}
                         type={"componenthead"}
                         headline={props.headline ? props.headline : props.cmCollection.teaserTitle}
                         propertyName={props.headline ? 'properties.headline' :
                             'properties.teaserTitle'}
            />
            <CCOContainer>
                <CCORichText metadataId={props.cmCollection.id}
                             textAsTree={props.cmCollection.teaserText?.textAsTree as RichTextElement}/>
            </CCOContainer>
            <CCOContainer width={"large"}><>
                <Grid container spacing={6} sx={{
                    justifyContent: "center"
                }}>
                    {props.cmCollection.items ? props.cmCollection.items?.map(i => i as CmTeasableType).map(
                        (i: any, index: number) => {
                            return (
                                <Grid
                                    key={index}
                                    size={{xs: 12, sm: 12, md: props.cmCollection.items!.length === 1 ? 12 : (props.cmCollection.items!.length === 2 ? 6 : 4)}}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'stretch'
                                    }}>
                                    <C021KachelTeaserDeprecatedCard useSquareImage={props.useSquareImage}
                                                                    item={i}
                                                                    teaser={true}
                                                                    orientation={props.cmCollection.items!.length ===
                                                                                 1 && greaterThanWindowMedium ?
                                                                        "landscape_ratio20x7" : "portrait_ratio1x1"}
                                                                    customStyle={{paddingX: '0!important'}}
                                                                    shouldUseResponsiveFontSize={shouldUseResponsiveFontSize}
                                                                    showAiGeneratedImageLabel
                                                                    teasercardLocation="CO21 Kachel-Teaser"
                                    />
                                </Grid>
                            );

                        }) : null
                    }
                </Grid></>
            </CCOContainer></CCOComponentWrapper>
    );
}

export default C021KachelTeaserDeprecated
